<template>
  <div class="app-nav">
    <nav class="nav">
      <div class="content">
        <a href="/" class="content-logo">
          <logo-text class="content-logo__symbol" />
        </a>

        <div class="content-right">
          <!-- <button @click="onChangeLang('NAV_LANG_KEY'.t())">{{"NAV_LANG".t()}}</button> -->
          <a target="_blank" href="https://medium.com/kokoa-finance">
            <svg width="22" height="22"><path d="M12.41 10.842c0 3.457-2.779 6.258-6.205 6.258C2.778 17.1 0 14.299 0 10.843s2.778-6.259 6.205-6.259 6.204 2.802 6.204 6.259ZM19.216 10.842c0 3.254-1.39 5.892-3.103 5.892-1.713 0-3.102-2.638-3.102-5.892 0-3.253 1.389-5.892 3.102-5.892 1.714 0 3.103 2.638 3.103 5.892M22 10.842c0 2.915-.488 5.278-1.091 5.278s-1.091-2.363-1.091-5.278c0-2.915.488-5.278 1.09-5.278.603 0 1.092 2.363 1.092 5.278Z" fill="#000"/></svg>
          </a>
          <a target="_blank" :href="'NAV_TELEGRAM'.t()">
            <svg width="20" height="20"><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" fill="#30AAE9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.527 9.894a475.72 475.72 0 0 1 5.831-2.512c2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.421.421 0 0 1 .142.271c.014.078.03.255.017.394-.15 1.581-.801 5.418-1.133 7.19-.14.749-.416 1-.683 1.024-.58.054-1.022-.383-1.584-.752-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177-.058-.052-.144-.034-.207-.02-.088.02-1.494.95-4.218 2.788-.399.274-.76.408-1.084.4-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657.022-.18.27-.364.744-.553Z" fill="#fff"/></svg>
          </a>
          <a target="_blank" href="https://docs.kokoa.finance">
            <span>{{"NAV_DOCS".t()}}</span>
          </a>
          <a target="_blank" href="https://app.kokoa.finance">
            <span>{{"NAV_APP".t()}}</span>
          </a>
        </div>
      </div>
    </nav>

    <nav class="nav-fixed" :class="show ? 'show' : ''">
      <div class="content">
        <a href="/" class="content-logo">
          <logo-text class="content-logo__symbol" />
        </a>

        <div class="content-right">
          <!-- <button @click="onChangeLang('NAV_LANG_KEY'.t())">{{"NAV_LANG".t()}}</button> -->
          <a target="_blank" href="https://medium.com/kokoa-finance">
            <svg width="22" height="22"><path d="M12.41 10.842c0 3.457-2.779 6.258-6.205 6.258C2.778 17.1 0 14.299 0 10.843s2.778-6.259 6.205-6.259 6.204 2.802 6.204 6.259ZM19.216 10.842c0 3.254-1.39 5.892-3.103 5.892-1.713 0-3.102-2.638-3.102-5.892 0-3.253 1.389-5.892 3.102-5.892 1.714 0 3.103 2.638 3.103 5.892M22 10.842c0 2.915-.488 5.278-1.091 5.278s-1.091-2.363-1.091-5.278c0-2.915.488-5.278 1.09-5.278.603 0 1.092 2.363 1.092 5.278Z" fill="#000"/></svg>
          </a>
          <a target="_blank" :href="'NAV_TELEGRAM'.t()">
            <svg width="20" height="20"><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" fill="#30AAE9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.527 9.894a475.72 475.72 0 0 1 5.831-2.512c2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.421.421 0 0 1 .142.271c.014.078.03.255.017.394-.15 1.581-.801 5.418-1.133 7.19-.14.749-.416 1-.683 1.024-.58.054-1.022-.383-1.584-.752-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177-.058-.052-.144-.034-.207-.02-.088.02-1.494.95-4.218 2.788-.399.274-.76.408-1.084.4-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657.022-.18.27-.364.744-.553Z" fill="#fff"/></svg>
          </a>
          <a target="_blank" href="https://docs.kokoa.finance">
            <span>{{"NAV_DOCS".t()}}</span>
          </a>
          <a target="_blank" href="https://app.kokoa.finance">
            <span>{{"NAV_APP".t()}}</span>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Logo from './Logo.vue';
import LogoText from './LogoText.vue';

export default {
  components: { Logo, LogoText },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    onChangeLang(lang) {
      this.$translateManager.change(lang);
    },
  },
  created() {
    var s = -1;

    window.addEventListener("scroll", e => {
      if (s != -1)
      {
        var dd = s - window.scrollY;
        if (dd > 0)
        {
          this.show = true;
        }
        else
        {
          this.show = false;
        }
      }

      s = window.scrollY;

      if (s < 62)
        this.show = false;
    });
  }
}
</script>

<style scoped>
.app-nav {
  height: 8.2rem;
}

.nav {
  height: 8.2rem;
}

.nav-fixed {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 8.2rem;
  z-index: 100;
  
  background: #fff;
  box-shadow: 0 0.26rem 0.26rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  transform: translateY(-100%);

  transition: opacity 0.2s, transform 0.2s;

  &.show {
    opacity: 1;
    transform: translateY(0);
  }
}

.content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  position: relative;
  padding: 0 1.3rem;
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  height: 100%;
}

.content-logo {

  & .content-logo__symbol {
    width: 21.1rem;
    height: 3.4rem;
  }
}

.content-right {
  display: flex;
  align-items: center;

  & button, & a {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0.66rem 1.2rem;
    color: #000;
    font-weight: 600;
    font-size: 1.33rem;
    line-height: 1;
    color: #7D6C60;

    & span {
      font-weight: 600;
      font-size: 2rem;
      line-height: 2.7rem;
    }
  }

  & a:last-child {
    margin-left: 1rem;
    width: 8.6rem;
    height: 3.4rem;
    background: #B8AA9F;
    border: 0.15rem solid #7D6C60;
    box-shadow: 0.2rem 0.2rem 0 #7D6C60;
    border-radius: 1.9rem;

    font-weight: 600;
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }
}

@media (max-width: 425px) {
  .app-nav, .nav, .nav-fixed {
    height: 5.5rem;
  }

  .content {
    padding: 0 1.8rem;
    justify-content: space-between;
  }

  .content-logo {
    position: static;
    transform: none;

    & .content-logo__symbol {
      width: 15rem;
      height: 2.4rem;
    }
  }

  .content-right {

    & a {
      padding: 0.66rem 0.66rem;
    }

    & a span {
      font-size: 1.2rem;
    }

    & a:last-child {
      margin-left: 0.5rem;

      width: 5.4rem;
      height: 2rem;
      background: #B8AA9F;
      border: 0.15rem solid #7D6C60;
      box-shadow: 0.1rem 0.1rem 0 #7D6C60;
      border-radius: 1.9rem;

      & span {
        font-size: 1rem;
        line-height: 1.4rem;
        letter-spacing: -0.01em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue